
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_v(','),_c('g',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1"}},[_c('path',{attrs:{"d":"M8.707 5.767L.93 13.545a1 1 0 001.414 1.414l7.778-7.778"}}),_c('path',{attrs:{"d":"M9.267.877l2.978 1.354 2.826 2.829a1 1 0 010 1.414L12.95 8.595a1 1 0 01-1.415 0L8.707 5.767 7.353 2.788a1.442 1.442 0 01.294-1.617h0a1.443 1.443 0 011.62-.294z"}})])])
          )
        }
      }
    